import PropTypes from "prop-types";
import React from "react";
import { AppInsightsTracker } from "components/Shared";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import logo from "static/images/logo.png";

class ComparableDetails extends AppInsightsTracker {
  constructor(props, context) {
    super(props, context);
    this.displayName = "ComparableDetails";
  }

  closeCurrentWindow() {
    // maybe put up a spinnaker?
    window.close();
  }

  render() {
    const { details } = this.props;
    let messageClass = "result-message " + details.hasError ? "error" : "success";
    const style = { maxWidth: 350, marginTop: 20 };
    const subTitle = details.controlNumber && details.controlNumber != 0
      ? `Control # ${details.controlNumber}`  // `  extra backtick to fix Chrome code display issue
      : "";

    return (
      <div className="md-grid md-cell login-wrapper">
        <div className="login-form">
          <img src={logo} alt="logo.png" className="mueller-logo" />
          <Card style={style} className="md-block-centered">
            <CardHeader className="md-card-title md-card-title--primary"
              title="Propmix Search Result"
              subheader={subTitle} />
            <CardContent style={{ minHeight: 200 }}>
              <div className={messageClass}>
                {details.message}
              </div>
            </CardContent>
            <CardActions className="md-divider-border md-divider-border--top">
              <Button className="right" onClick={this.closeCurrentWindow}>
                Return to Mueller Collateral Connect
              </Button>
            </CardActions>
          </Card>
        </div>
      </div>
    );
  }
}

ComparableDetails.propTypes = {
  details: PropTypes.object
};

export default ComparableDetails;
